import { useState, useEffect } from 'react'
import { gql } from '@apollo/client'
import { Table, Alert } from 'reactstrap'
import Spinner from '../../Spinner/Spinner.js'
import { getData } from '../CustomUtils'
import ReportHeading from '../ReportHeading.js'
import ColumnHeadings from '../ColumnHeadings.js'
import { CIRCULAR_REFERENCES_QUERY } from '../../../graphql.js'
import ReportGrid from '../ReportGrid'
import '../Custom.css'

const CIRCULAR_REFERENCES = gql(CIRCULAR_REFERENCES_QUERY)

export default function CircularReferences({ location }) {
  console.log('CircularReferences rendered')

  const [results, setResults] = useState()
  const [graphQLErrors, setGraphQLErrors] = useState([])

  useEffect(() => {
    getData(location, CIRCULAR_REFERENCES, 'circularReferences', setResults, setGraphQLErrors)
  }, [location])

  if (graphQLErrors.length > 0) {
    return <Alert color="danger">{graphQLErrors[0].message}</Alert>
  } else if (!results) {
    return <Spinner />
  } else {
    return (
      <div className="custom-scroll">
        <Table bordered style={{backgroundColor: 'white', width: 'auto', minWidth: '800px', margin: 'auto'}} >
          <ReportHeading title={'Circular References'} />
          <tbody>
            <ColumnHeadings results={results} />
            <ReportGrid results={results} />
          </tbody>
        </Table>
      </div>
    )
  }
}